import { AdminType, APIGet, APIUrl } from "api/protocols";

interface IGetAccommodationCategory {
  id?: number;
  category_id?: number;
  facility_id: number;
}

export interface IPostAccommodationCategory {
  title: string;
}

export interface IPutAccommodationCategory {
  id: number;
  title: string;
}

// GET Accommodation Categories
export async function GetAccommodationCategories(params: IGetAccommodationCategory, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.Customer, "/accommodation/categories"), params, useGlobalLoader);
}
